import { AppRootStateType } from 'state/store';

export const notificationsSelect = (state: AppRootStateType) =>
  state.notifications.notifications;
export const notificationSelect = (state: AppRootStateType) =>
  state.notifications.notification;
export const adminNotificationsSelect = (state: AppRootStateType) =>
  state.notifications.notificationAdmin;
